interface CalculatePrizeProps {
  prizeList: any[];
  inputVal: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  currency?: string;
}

const CalculatePrize = ({
  prizeList,
  inputVal,
  handleInputChange,
  currency = "$",
}: CalculatePrizeProps) => {
  return (
    <div
      className={`flex flex-col min-h-[165px] p-5
                rounded-[10px] bg-tm-c-gray-950 border border-tm-c-gray-700
                lg:min-h-[200px] lg:py-6 lg:px-[30px]
                min-[1041px]:!min-h-[300px]
              `}
    >
      <span className="text-xs md:text-base mb-5 lg:mb-7.5">
        Calculate prize money
      </span>
      <span className="text-xs text-tm-c-gray-300 mb-1">Rank</span>
      <input
        className={`h-[35px] w-full px-1.5 mb-3.5
                  rounded-md bg-tm-c-gray-800 border border-[#d9d9d9]
                text-white text-base
                placeholder-white/50 placeholder:text-base
                  focus:outline-none focus:ring-0
                `}
        type="number"
        defaultValue={inputVal}
        onChange={handleInputChange}
        placeholder="Enter rank"
      />
      <div className="text-xl font-medium">
        {currency}
        {prizeList[parseInt(inputVal) - 1]?.toLocaleString("en-US") || "0"}
      </div>
    </div>
  );
};

export default CalculatePrize;
